import { useState, useEffect } from "react";
import { Nav, Footer } from "../components/Nav";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-[#FAFAFA]">
      <Nav />
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-20 pb-32">
        <p className="overline mb-8"><span className="gold-line mr-3" />Enquiries</p>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl leading-[1.05]">Frequently, quietly asked.</h1>
        <div className="mt-16">
          <Accordion type="single" collapsible className="border-t border-black/10">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={`q-${i}`} className="border-b border-black/10">
                <AccordionTrigger data-testid={`faq-${i}`} className="font-serif-display text-xl py-6 text-left hover:no-underline">{f.question}</AccordionTrigger>
                <AccordionContent className="pb-6 text-[#3a3a3a] leading-relaxed whitespace-pre-wrap">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. Thank you.");
      setForm({ name: "", email: "", message: "" });
    } catch { toast.error("Failed to send"); }
    finally { setLoading(false); }
  };
  return (
    <div className="bg-[#FAFAFA]">
      <Nav />
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-20 pb-32 grid grid-cols-1 md:grid-cols-12 gap-14">
        <div className="md:col-span-5">
          <p className="overline mb-8"><span className="gold-line mr-3" />Contact</p>
          <h1 className="font-serif-display font-light text-4xl md:text-5xl leading-tight">Write to the studio.</h1>
          <p className="mt-6 text-[#3a3a3a] leading-relaxed">For enquiries about the course, collaborations, or press, please leave a note. We reply within 48 hours.</p>
        </div>
        <form onSubmit={submit} className="md:col-span-7 space-y-6" data-testid="contact-form">
          <div>
            <label className="overline no-underline">Name</label>
            <input required data-testid="contact-name" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="w-full bg-transparent py-3 border-b border-black/20 focus:border-black focus:outline-none outline-none" />
          </div>
          <div>
            <label className="overline no-underline">Email</label>
            <input required type="email" data-testid="contact-email" value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} className="w-full bg-transparent py-3 border-b border-black/20 focus:border-black focus:outline-none outline-none" />
          </div>
          <div>
            <label className="overline no-underline">Message</label>
            <textarea required rows={5} data-testid="contact-message" value={form.message} onChange={(e)=>setForm({...form, message: e.target.value})} className="w-full bg-transparent py-3 border-b border-black/20 focus:border-black focus:outline-none outline-none resize-none" />
          </div>
          <button disabled={loading} data-testid="contact-submit" className="btn-editorial">{loading ? "Sending…" : "Send Message"}</button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
